export const loginTranslations = {
  en: {
    hero: {
      welcome: 'Welcome to',
      location: 'Palm Beach | Broward | Miami Dade',
      headline: 'Connecting Home Chefs with Food Lovers in Your Community',
      description: 'Discover delicious, home-cooked meals from local chefs, or share your culinary creations with neighbors who appreciate authentic, homemade food.',
      houseOfHomeCooking: 'The House of',
      homeCooking: 'Home Cooking',
    },
    form: {
      signIn: 'Sign in to Your Account',
      invalidCredentials: 'Invalid username or password',
      email: 'Email',
      password: 'Password',
      forgotPassword: 'Forgot password',
      login: 'Login',
      validEmail: 'Please enter a valid email address',
    },
    welcomeVerbiage: {
      title: 'Ready to Get Started?',
      description: 'Create your account today and become part of {appName} community. It only takes a few minutes!',
      registerNow: 'Register Now',
    },
    howItWorks: 'How It Works',
    customer: {
      title: 'For Food Lovers',
      steps: {
        one: {
          title: '1. Search by Location',
          description: 'Sign up as a customer and find open kitchens near you to connect with local home chefs',
        },
        two: {
          title: '2. Browse Menus',
          description: 'Explore diverse cuisines and homemade dishes from local chefs',
        },
        three: {
          title: '3. Order & Enjoy',
          description: 'Place your order and track the status, pay your chef directly and enjoy authentic, home-cooked meals',
        },
      },
    },
    chef: {
      title: 'For Home Chefs',
      steps: {
        one: {
          title: '1. Set Up Your Kitchen',
          description: 'Register your home kitchen and get started with your profile',
        },
        two: {
          title: '2. Create Your Menu',
          description: 'Showcase your culinary specialties and set your own prices',
        },
        three: {
          title: '3. Grow Your Business',
          description: 'Manage orders, and build your customer base',
        },
      },
    },
    quote: {
      text: '"A recipe has no soul. You as the cook must bring soul to the recipe."',
      author: 'Thomas Keller',
    },
    error: {
      generic: 'Sorry, something went wrong.',
    },
  },
  es: {
    hero: {
      welcome: 'Bienvenido a',
      location: 'Palm Beach | Broward | Miami Dade',
      headline: 'Conectando chefs de hogar con amantes de la comida de tu comunidad',
      description: 'Descubre comidas deliciosas y caseras de chefs locales, o comparte tus creaciones culinarias con vecinos que valoran la comida auténtica y hecha en casa.',
      houseOfHomeCooking: 'La casa de',
      homeCooking: 'cocina casera',
    },
    form: {
      signIn: 'Inicia sesión en tu cuenta',
      invalidCredentials: 'Usuario o contraseña inválidos',
      email: 'Correo electrónico',
      password: 'Contraseña',
      forgotPassword: 'Olvidé mi contraseña',
      login: 'Iniciar sesión',
      validEmail: 'Por favor, introduce un correo electrónico válido',
    },
    welcomeVerbiage: {
      title: '¿Listo para comenzar?',
      description: 'Crea tu cuenta hoy y forma parte de la comunidad de {appName}. ¡Solo toma unos minutos!',
      registerNow: 'Regístrate ahora',
    },
    howItWorks: 'Cómo funciona',
    customer: {
      title: 'Para amantes de la comida',
      steps: {
        one: {
          title: '1. Busca por ubicación',
          description: 'Regístrate como cliente y encuentra cocinas abiertas cerca de ti para conectarte con chefs locales',
        },
        two: {
          title: '2. Explora menús',
          description: 'Descubre una variedad de cocinas y platos caseros de chefs locales',
        },
        three: {
          title: '3. Pide y disfruta',
          description: 'Haz tu pedido y dale seguimiento, paga directamente a tu chef y disfruta comidas auténticas hechas en casa',
        },
      },
    },
    chef: {
      title: 'Para chefs de hogar',
      steps: {
        one: {
          title: '1. Configura tu cocina',
          description: 'Registra tu cocina en casa y comienza con tu perfil',
        },
        two: {
          title: '2. Crea tu menú',
          description: 'Muestra tus especialidades culinarias y define tus propios precios',
        },
        three: {
          title: '3. Haz crecer tu negocio',
          description: 'Gestiona pedidos y construye tu base de clientes',
        },
      },
    },
    quote: {
      text: '"Una receta no tiene alma. Eres tú quien debe darle alma a la receta."',
      author: 'Thomas Keller',
    },
    error: {
      generic: 'Lo sentimos, algo salió mal.',
    },
  },
};
